import passwordSwitcher from "./Components/passwordVisibilitySwitcher";

const getInputs = () => {
  return new Promise((resolve, reject) => {
    const inputs = document.querySelectorAll(".password-wrapper");

    if (inputs.length > 0) resolve([...inputs]);

    reject();
  });
};

const initSwitcher = (inputs) => {
  return new Promise((resolve, reject) => {
    inputs.forEach((input) => {
      new passwordSwitcher(input);
    });
    resolve();
  });
};

async function handleSwitcher() {
  try {
    const inputs = await getInputs();
    await initSwitcher(inputs);
  } catch (e) {}
}

document.addEventListener("DOMContentLoaded", () => {
  handleSwitcher();
});
